import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
} from '@mui/material';
import { saveCandidateName } from '../pages/create-activity/activityHelper';
import { useAppDispatch } from '../store/redux-hooks';
const CandidateNameEdit = ({
  user,
  setEnableEditValue,
  candidateId,
  loggedCandidateID,
  refreshData,
  setShowLoader,
}: any) => {
  const [enableEdit, setEnableEdit] = useState(false);
  const [tempFirstName, setTempFirstName] = useState(user?.firstname || '');
  const [tempLastName, setTempLastName] = useState(user?.lastname || '');
  const dispatch = useAppDispatch();
  useEffect(() => {
    setEnableEdit(true);
  }, []);
  const isValidName = (name: string) => {
    const trimmedName = name.trim();
    const nameRegex = /^[a-zA-Z .]{2,}$/;
    const hasAtLeastOneLetter = /[a-zA-Z]/.test(trimmedName);
    return nameRegex.test(trimmedName) && hasAtLeastOneLetter;
  };
  const handleCancelClick = () => {
    setEnableEdit(false);
    setEnableEditValue(false);
  };
  const handleSaveClick = async () => {
    if (!isValidName(tempFirstName) || !isValidName(tempLastName)) {
      alert('Please enter valid names.');
      return;
    }
    console.log('API Call with:', {
      firstName: tempFirstName,
      lastName: tempLastName,
    });
    await saveCandidateName(
      tempFirstName,
      tempLastName,
      candidateId,
      loggedCandidateID,
      dispatch,
      refreshData,
      setShowLoader
    );
    setEnableEdit(false);
    setEnableEditValue(false);
  };
  return (
    <div>
      <Dialog
        open={enableEdit}
        onClose={handleCancelClick}
        PaperProps={{
          style: {
            minWidth: 420,
            maxWidth: 420,
            minHeight: 250,
          },
        }}
      >
        <DialogTitle style={{ fontSize: '16px', fontWeight: 600 }}>
          Edit Candidate Name
        </DialogTitle>
        <DialogContent
          style={{
            paddingBottom: 16,
          }}
        >
          <TextField
            label="First Name"
            value={tempFirstName}
            onChange={(e) => {
              const value = e.target.value;
              if (value === '' || /^[a-zA-Z\s.]*$/.test(value)) {
                setTempFirstName(value);
              }
            }}
            error={!isValidName(tempFirstName)}
            helperText={
              !isValidName(tempFirstName)
                ? 'Enter atleast 2 characters with no special characters'
                : ' '
            }
            fullWidth
            margin="dense"
            variant="outlined"
            InputProps={{
              style: { fontSize: '14px' },
            }}
            InputLabelProps={{
              style: { fontSize: '14px' },
            }}
          />
          <TextField
            label="Last Name"
            value={tempLastName}
            onChange={(e) => {
              const value = e.target.value;
              if (value === '' || /^[a-zA-Z\s.]*$/.test(value)) {
                setTempLastName(value);
              }
            }}
            error={!isValidName(tempLastName)}
            helperText={
              !isValidName(tempLastName)
                ? 'Enter atleast 2 characters with no special characters'
                : ' '
            }
            fullWidth
            margin="dense"
            variant="outlined"
            InputProps={{
              style: { fontSize: '14px' },
            }}
            InputLabelProps={{
              style: { fontSize: '14px' },
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelClick} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSaveClick} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default CandidateNameEdit;
